// extracted by mini-css-extract-plugin
module.exports = {"label":"label__pVQTHjUgEj+yH","success":"success__FiiHLMneoxBOk","warning":"warning__gKAXds+4jYBio","error":"error__jRuVlppTunpw7","default":"default__ZLXjtdhUWcOl4"};